import { createSlice } from "@reduxjs/toolkit";

const btnrec=createSlice({
    name:"btnrec",
    initialState:{r:0},
    reducers:{
        setBtnrecS:(state,action)=>{
            state.r=action.payload
        }
    }
});

export const {setBtnrecS}=btnrec.actions;
export default btnrec.reducer;